import axios from '@/axiosInterceptor';

const state = () => ({
  currentVerification: {},
  emailVerification: {},
  challenge_question_required: false,
  challenge_question: 'What make of power units do you primarily run?',
  challenge_question_answer: '',
  challenge_question_answer_options: [
    'Freightliner',
    'Peterbilt',
    'Kenworth',
    'Navistar',
  ],
  comparator: 1,
  dispatcher_challenge_question_required: false,
  dispatcher_challenge_question:
    'What make of power units do you primarily run?',
  dispatcher_challenge_question_answer: '',
  dispatcher_challenge_question_answer_options: [
    'Freightliner',
    'Peterbilt',
    'Kenworth',
    'Navistar',
  ],
  dispatcher_comparator: 1,
});

const getters = {};

// actions

const actions = {
  async createVerification({ commit }, phone_number) {
    try {
      let verification_body = {
        verification: {
          channel: 'sms',
          verifiable_type: 'AddPhone',
          phone: phone_number,
        },
      };
      let res = await axios.post(
        process.env.API_IDENTITY + '/api/v1/verifications',
        verification_body
      );
      commit('updateCurrentVerification', res.data);
      return res;
    } catch (e) {
      let status = e.response?.status;
      if (
        axios.isAxiosError(e) &&
        status &&
        [401, 403, 404, 422].includes(status)
      ) {
        return e.response;
      } else {
        throw e;
      }
    }
  },

  async confirmVerification({ commit }, data) {
    try {
      let verification_body = { code: data.code };
      let res = await axios.patch(
        process.env.API_IDENTITY +
          '/api/v1/verifications/' +
          data.verification_id +
          '/verify',
        verification_body
      );
      commit('updateCurrentVerification', res.data);
      return res;
    } catch (e) {
      let status = e.response?.status;
      if (
        axios.isAxiosError(e) &&
        status &&
        [401, 403, 404, 422].includes(status)
      ) {
        return e.response;
      } else {
        throw e;
      }
    }
  },
  async getVerifications(_, filter) {
    try {
      var params = {
        page: 1,
        per_page: 50,
        'q[s]': 'id desc',
      };

      if (filter.channel) {
        params['q[channel_eq]'] = filter.channel;
      }

      let res = await axios.get(
        process.env.API_IDENTITY + '/api/v1/verifications',
        {
          params: params,
        }
      );

      return res;
    } catch (e) {
      let status = e.response?.status;
      if (
        axios.isAxiosError(e) &&
        status &&
        [401, 403, 404, 422].includes(status)
      ) {
        return e.response;
      } else {
        throw e;
      }
    }
  },
  async getEmailVerification({ dispatch, commit }) {
    const filter = {
      channel: 'email',
    };

    const result = await dispatch('getVerifications', filter);
    commit('setEmailVerification', result.data[0]);
  },
  async resendVerification(_, verificationId) {
    try {
      let res = await axios.patch(
        process.env.API_IDENTITY +
          '/api/v1/verifications/' +
          verificationId +
          '/resend'
      );

      return res;
    } catch (e) {
      let status = e.response?.status;
      if (
        axios.isAxiosError(e) &&
        status &&
        [401, 403, 404, 422].includes(status)
      ) {
        return e.response;
      } else {
        throw e;
      }
    }
  },
  async resendEmailVerification(_, userId) {
    try {
      let res = await axios.post(
        process.env.API_IDENTITY +
          '/api/v1/users/' +
          userId +
          '/resend_email_verification'
      );

      return res;
    } catch (e) {
      let status = e.response?.status;
      if (
        axios.isAxiosError(e) &&
        status &&
        [401, 403, 404, 422].includes(status)
      ) {
        return e.response;
      } else {
        throw e;
      }
    }
  },
  async verifyChallengeQuestion({ state }) {
    if (state.challenge_question_answer?.length > 0) {
      let idx = state.challenge_question_answer_options?.indexOf(
        state.challenge_question_answer
      );
      if (idx === state.comparator) {
        return 'challenge_successful';
      } else {
        return 'challenge_failed';
      }
    } else {
      return 'challenge_failed';
    }
  },
  async verifyDispatcherChallengeQuestion({ state }) {
    if (state.dispatcher_challenge_question_answer?.length > 0) {
      let idx = state.dispatcher_challenge_question_answer_options?.indexOf(
        state.dispatcher_challenge_question_answer
      );
      if (idx === state.dispatcher_comparator) {
        return 'dispatcher_challenge_successful';
      } else {
        return 'dispatcher_challenge_failed';
      }
    } else {
      return 'dispatcher_challenge_failed';
    }
  },
};

//mutations
const mutations = {
  updateCurrentVerification(state, verificationUpdate) {
    state.currentVerification = verificationUpdate;
  },
  setEmailVerification(state, verification) {
    state.emailVerification = verification;
  },
  setChallengeAnswer(state, data) {
    state.challenge_question_answer = data;
  },
  setRequireChallenge(state, bool) {
    state.challenge_question_required = bool;
  },
  setDispatcherChallengeAnswer(state, data) {
    state.dispatcher_challenge_question_answer = data;
  },
  setRequireChallengeDispatcher(state, bool) {
    state.dispatcher_challenge_question_required = bool;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
